export enum ExperimentFlags {
  EXPERIMENT_USE_DISCOVERY_JOURNEY = "experiment-use-discovery-journey",
  GUEST_PRICE_V3 = "page-experiment-guest-price-v3",
  OOS_SIMILAR_TO_EXPERIMENT = "page-experiment-show-similar-to",
  PAGE_EXPERIMENT_CLOUDINARY_LOADER = "page-experiment-cloudinary-loader",
  PAGE_EXPERIMENT_CONSTRUCTOR_BROWSE = "page-experiment-constructor-browse",
  PAGE_EXPERIMENT_CONTENT_FOR_DISCOVERY_JOURNEY = "page-experiment-test-discovery-journey",
  PAGE_EXPERIMENT_OPENGATE = "page-experiment-opengate",
  PAGE_EXPERIMENT_PDP_WITH_OPEN_GATE_UI = "page-experiment-pdp-with-open-gate-ui",
  PAGE_EXPERIMENT_US_JOURNEY = "page-experiment-us-journey",
  PRODUCT_COMPARISON_EXPERIMENT_V3 = "experiment-product-comparison-v3",
  SHOW_ORDER_IT_AGAIN_PAGE = "show-favourites-order-it-again",
  USE_ATBL_V2 = "use-atbl-v2",
  USE_BLOG_MINIFIED_DATA = "use-blog-minified-data",
  USE_MEMBER_BENEFITS_PAGE = "experiment-use-member-benefits",
  USE_PROMO_CODE_EXPERIMENT = "use-promo-code-experiment",
  PAGE_EXPERIMENT_FOR_YOU_RECOMMENDATIONS_MHP = "page-experiment-for-you-recommendations-mhp",
  USE_NEW_WISHLIST_DESIGN = "use-new-wishlist-design",
  PAGE_EXPERIMENT_PRODUCT_FIRST_PLUS = "page-experiment-product-first-plus",
  PAGE_EXPERIMENT_PRODUCT_FIRST_MINI = "page-experiment-product-first-mini",
  PAGE_EXPERIMENT_NEW_OG_MAPPING = "page-experiment-new-og-mapping",
  SHOW_OIA_ON_SEARCH = "experiment-oia-on-search",
  SHOW_DIGIOH_POPUP = "show-digioh-popup",
  SHOW_ANNIVERSARY_GIFT_TEASER = "experiment-anniversary-gift-teaser",
  PAGE_EXPERIMENT_AUTOPLAY_VIDEO = "page-experiment-autoplay-video",
  SHOW_MEMBER_TENURE_FROM_UPS = "show-member-tenure",
  PAGE_EXPERIMENT_FREE_TRIAL_2 = "page-experiment-free-trial-2",
  EXPERIMENT_QUIZ_MODEL_V2 = "experiment-quiz-model-v2",
  PAGE_EXPERIMENT_BUNDLES_FAKE_DOOR = "page-experiment-bundles-fake-door",
  PAGE_EXPERIMENT_STRIKETHROUGH = "page-experiment-strikethrough",
  PAGE_EXPERIMENT_PAIRS_WITH = "page-experiment-pairs-with",
  PAGE_EXPERIMENT_PROMO_VIS_PDP = "page-experiment-promo-vis-pdp",
  PAGE_EXPERIMENT_PDP_NO_DEFAULT = "page-experiment-pdp-no-default",
  PAGE_EXPERIMENT_PATB_AND_FT_EXPERIMENT = "page-experiment-patb-and-ft-experiment",
  PAGE_EXPERIMENT_QUIZ_V10 = "page-experiment-quiz-v10",
  PAGE_EXPERIMENT_PDP_COMPARISON_TABLE = "page-experiment-pdp-comparison-table",
  PAGE_EXPERIMENT_QUIZ_RESULTS_STACKED = "page-experiment-quiz-results-stacked-am-pm",
  PAGE_EXPERIMENT_QUIZ_MINI_NAV = "page-experiment-quiz-mini-nav",
  SMS_OPT_IN = "sms-opt-in",
  USE_MEMBERSHIP_HOTJAR_SURVEY = "use-hotjar-membership-survey",
  PAGE_EXPERIMENT_QUIZ_MODEL_V3 = "page-experiment-quiz-model-v3",

}

export const PAGE_EXPERIMENT_OPENGATE = {
  name: "page-experiment-opengate",
  values: {
    CONTROL: 0,
    THROWAWAY: 1,
    PLUS: 2,
    MINI: 3,
    PLUS_TAB: 4,
    MINI_TAB: 5
  }
};

export const PAGE_EXPERIMENT_PDP_WITH_OPEN_GATE_UI = {
  name: "page-experiment-pdp-with-open-gate-ui",
  values: {
    CONTROL: 0,
    VARIANT: 1,
    THROWAWAY_CONTROL: 2,
    THROWAWAY_VARIANT: 3
  }
};

export const PAGE_EXPERIMENT_BUNDLES_FAKE_DOOR = {
  name: "page-experiment-bundles-fake-door",
  values: {
    NO_FLAG: -1,
    CONTROL: 0,
    NO_DISCOUNT: 1,
    BUNDLES: 2,
    ROUTINES: 3
  }
};

export const PAGE_EXPERIMENT_STRIKETHROUGH = {
  name: "page-experiment-strikethrough",
  values: {
    CONTROL: 0,
    VARIANT: 1,
    THROWAWAY_CONTROL: 2,
    THROWAWAY_VARIANT: 3
  }
};

export const PAGE_EXPERIMENT_PROMO_VIS_PDP = {
  name: "page-experiment-promo-vis-pdp",
  values: {
    CONTROL: 0,
    VARIANT: 1,
    THROWAWAY_CONTROL: 2,
    THROWAWAY_VARIANT: 3
  }
};

export const PAGE_EXPERIMENT_PAIRS_WITH = {
  name: "page-experiment-pairs-with",
  values: {
    NO_FLAG: -1,
    CONTROL: 0,
    VARIANT_1: 1,
    VARIANT_2: 2,
    THROWAWAY_CONTROL: 3,
    THROWAWAY_VARIANT_1: 4,
    THROWAWAY_VARIANT_2: 5
  }
};

export const PAGE_EXPERIMENT_PDP_NO_DEFAULT = {
  name: "page-experiment-pdp-no-default",
  values: {
    NO_FLAG: -1,
    CONTROL: 0,
    VARIANT_1: 1,
    VARIANT_2: 2,
    THROWAWAY_CONTROL: 3,
    THROWAWAY_VARIANT_1: 4,
    THROWAWAY_VARIANT_2: 5,
    BYPASS: 6
  }
};

export const PAGE_EXPERIMENT_PDP_COMPARISON_TABLE = {
  name: ExperimentFlags.PAGE_EXPERIMENT_PDP_COMPARISON_TABLE,
  values: {
    CONTROL: 0,
    VARIANT: 1,
    THROWAWAY_CONTROL: 2,
    THROWAWAY_VARIANT: 3
  }
};
